// extracted by mini-css-extract-plugin
module.exports = {"wrap":"select-address-dialog_wrap__2CKok","decideButton":"select-address-dialog_decideButton__3FNbj"};